var config;
export function getConfig() {
    if (config) {
        return Promise.resolve(config);
    }
    /*
     * We considered using the window.environment
     * configuration, but that cannot be
     * guaranteed across all teams. So for now,
     * the config will be fetched via API
     * and anyone using a microfrontend will
     * need to make sure they have a revers
     * proxy for the config.
     */
    var location = window.location.origin;
    // THIS SHOULD NOT BE IN PRODUCTION! REMOVE AFTER TESTING
    if (/qa3-buy/.test(location)) {
        location = 'https://qa3-app.matterport.com';
    }
    return fetch("".concat(location, "/api/v2/config/mp-ui"))
        .then(function (response) {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response;
    })
        .then(function (data) { return data.json(); })
        .then(function (data) {
        config = data;
        return data;
    });
}
